import { Button, Card } from "@/components/primitives";
import { useAihrAuth } from "@/lib/auth/useAihrAuth";

export function ForbiddenPage() {
  const auth = useAihrAuth();

  return (
    <div className="center-screen">
      <Card className="signin-card">
        <h1>Access restricted</h1>
        <p>Cosmos is only available to authorized AIHR accounts.</p>
        <Button onClick={() => auth.logout()}>Sign out</Button>
      </Card>
    </div>
  );
}
